import { render, staticRenderFns } from "./FAQCRUD.vue?vue&type=template&id=05dd3b9e&"
import script from "./FAQCRUD.vue?vue&type=script&lang=js&"
export * from "./FAQCRUD.vue?vue&type=script&lang=js&"
import style0 from "./FAQCRUD.vue?vue&type=style&index=0&id=05dd3b9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports